import { async } from 'regenerator-runtime';
import { AJAX } from './helpers';
import { API_URL, RES_PER_PAGE, KEY } from './config.js';

export const state = {
  recipe: {},
  bookmarks: [],
  shoppingList: [],
  search: {
    query: ``,
    results: [],
    page: 1,
    resultsPerPage: RES_PER_PAGE,
    ascending: { ingNum: true, cookingTime: true },
  },
};

const createRecipeObject = function (data) {
  const { recipe } = data.data;
  return {
    id: recipe.id,
    imageUrl: recipe.image_url,
    ingredients: recipe.ingredients,
    publisher: recipe.publisher,
    servings: recipe.servings,
    sourceUrl: recipe.source_url,
    title: recipe.title,
    cookingTime: recipe.cooking_time,
    ingNum: recipe.ingredients.length + 1,
    ...(recipe.key && { key: recipe.key }),
  };
};

export const loadRecipe = async function (id) {
  try {
    const data = await AJAX(`${API_URL}${id}?key=${KEY}`);
    state.recipe = createRecipeObject(data);
    state.recipe.bookmarked = state.bookmarks.some(
      bookmark => bookmark.id === id
    );
    state.recipe.shoppingListed = state.shoppingList.some(
      item => item.id === id
    );
  } catch (err) {
    throw err;
  }
};

export const loadSearcResults = async function (query) {
  try {
    state.search.query = query;
    const data = await AJAX(`${API_URL}/?search=${query}&key=${KEY}`);
    const { recipes } = data.data;
    state.search.results = await Promise.all(
      recipes.map(async recipe => {
        const data = await AJAX(`${API_URL}${recipe.id}?key=${KEY}`);
        return {
          id: recipe.id,
          publisher: recipe.publisher,
          imageUrl: recipe.image_url,
          title: recipe.title,
          cookingTime: data.data.recipe.cooking_time,
          ingNum: data.data.recipe.ingredients.length + 1,
        };
      })
    );
    console.log(state.search.results);
  } catch (err) {
    console.log(err);
  }
};

export const getSearchResultsPage = function (page = state.search.page) {
  state.search.page = page;
  return state.search.results.slice(
    state.search.resultsPerPage * (page - 1),
    state.search.resultsPerPage * page
  );
};

export const updateServings = function (updateTo) {
  if (updateTo === 0) return;
  state.recipe.ingredients.forEach(ing => {
    ing.quantity = (ing.quantity * updateTo) / state.recipe.servings;
  });
  state.recipe.servings = updateTo;
  console.log(state.recipe);
};

export const addRemoveBookmark = function (recipe) {
  if (!recipe.bookmarked) {
    state.bookmarks.push(recipe);
    if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;
    addRemoveLocalStorage(`bookmarks`);
  } else {
    const index = state.bookmarks.findIndex(
      bookmark => bookmark.id === recipe.id
    );
    state.bookmarks.splice(index, 1);
    if (recipe.id === state.recipe.id) state.recipe.bookmarked = false;
    addRemoveLocalStorage(`bookmarks`);
  }
};

const addRemoveLocalStorage = function (objName) {
  if (!state[objName]) return;
  localStorage.setItem(objName, JSON.stringify(state[objName]));
};

export const addNewRecipe = async function (newRecipe) {
  try {
    const ingsArr = Object.entries(newRecipe)
      .filter(item => item[0].startsWith(`ing`))
      .map(ing => [ing[0].slice(3), ing[1]]);
    const ingredients = [];
    for (let i = 1; i <= (ingsArr.length + 1) / 3; i++) {
      ingredients.push(
        Object.fromEntries(
          ingsArr
            .filter(ing => ing[0].startsWith(i))
            .map(el => [
              el[0].split(`-`)[1],
              el[0].split(`-`)[1] === `quantity` && el[1] === `` ? null : el[1],
            ])
        )
      );
    }
    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: +newRecipe.cookingTime,
      servings: +newRecipe.servings,
      ingredients,
    };

    const data = await AJAX(`${API_URL}?key=${KEY}`, recipe);
    state.recipe = createRecipeObject(data);
    addRemoveBookmark(state.recipe);
  } catch (err) {
    throw err;
  }
};

export const addRemoveShoppngList = function (recipe) {
  if (!recipe.shoppingListed) {
    state.shoppingList.push(recipe);
    if (recipe.id === state.recipe.id) state.recipe.shoppingListed = true;
    addRemoveLocalStorage(`shoppingList`);
  } else {
    const index = state.shoppingList.findIndex(item => item.id === recipe.id);
    state.shoppingList.splice(index, 1);
    if (recipe.id === state.recipe.id) state.recipe.shoppingListed = false;
    addRemoveLocalStorage(`shoppingList`);
  }
};

export const findRecipeShoppingList = function (id) {
  const recipe = state.shoppingList.find(el => el.id === id);
  return recipe;
};

export const sortResults = function (sortBy) {
  if (state.search.ascending[sortBy]) {
    state.search.results.sort((a, b) => a[sortBy] - b[sortBy]);
    state.search.ascending[sortBy] = false;
  } else {
    state.search.results.sort((a, b) => b[sortBy] - a[sortBy]);
    state.search.ascending[sortBy] = true;
  }
};

const takeDataFromLocalStorage = function () {
  Object.keys(localStorage).forEach(el => {
    if (!state[el]) return;
    state[el] = JSON.parse(localStorage.getItem(el));
  });
};

const init = function () {
  takeDataFromLocalStorage();
};

init();
